import { ModalContainer, SectionHeader } from "../../../components";
import { countries } from "../../../constants";
import { HookFormSelect, SubmitButton, TextInput } from "../../../hook-form";
import { formatAsCurrency, getCurrencySymbol } from "../../../utils";
import { ICreateMerchantDedicatedTopUpAccountFormViewProps } from "./CreateMerchantDedicatedTopUpAccount";

export const View = ({
  isModalOpen,
  closeModal,

  isLoadingBalances,
  balances,

  isLoadingPartnerBankList,
  partnerBankList,

  formValues,
  errors,
  handleSubmit,
  register,
}: ICreateMerchantDedicatedTopUpAccountFormViewProps) => {
  return (
    <form onSubmit={handleSubmit} className="create-dedicated-topup-acc--form">
      <ModalContainer
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        modalHeader={
          <SectionHeader
            title="Create New Top-Up Account"
            subtitle="Create an account you can use to top-up your balance"
          />
        }
      >
        <div className="flex-container flex-break--small">
          <div className="flex-box">
            <HookFormSelect
              name="country"
              label="Country To Reserve Bank Account"
              selectItems={[]}
              selectGroupedItems={countries}
              register={register}
              errors={errors}
              // disabled={formValues.link_account_verification_with_main_account}
            />
          </div>

          <div className="flex-box ml-md-5">
            <HookFormSelect
              name="currency"
              label="Currency"
              showSkeleton={isLoadingBalances}
              selectItems={balances.map((bal) => ({
                text: `${bal.currency} (${getCurrencySymbol(bal.currency)})`,
                value: bal.currency,
              }))}
              register={register}
              errors={errors}
            />
          </div>
        </div>

        <div className="flex-container flex-break--small">
          <div className="flex-box">
            <HookFormSelect
              name="preferred_bank_code"
              label="Bank"
              // infoIconText="The withdrawal bank"
              showSkeleton={isLoadingPartnerBankList}
              selectItems={partnerBankList.map((bnk) => ({
                text: bnk.bank_name,
                value: bnk.bank_code,
              }))}
              register={register}
              errors={errors}
              disabled={!formValues.country || !formValues.currency}
            />
          </div>

          <div className="flex-box ml-md-5">
            <TextInput
              name="account_reference"
              label="Account Reference (Optional)"
              infoIconText=""
              type="text"
              register={register}
              errors={errors}
            />
          </div>
        </div>

        <div className="flex-container flex-break--small">
          <div className="flex-box">
            <TextInput
              name="bvn"
              label="Bvn Of Merchant/User"
              infoIconText="The BVN must be tied to this business for regulatory purposes"
              type="text"
              register={register}
              errors={errors}
            />
          </div>

          <div className="flex-box ml-md-5">
            <TextInput
              name="nin"
              label="NIN Of Merchant/User (Optional)"
              infoIconText="The NIN must be tied to this business for regulatory purposes"
              type="text"
              register={register}
              errors={errors}
            />
          </div>
        </div>

        <div className="flex-container submit-button--container">
          <SubmitButton
            // size="md"
            className="mt-5 flex-box"
            showChildrenWithLoadingIcon
          >
            Create Account
          </SubmitButton>
        </div>
      </ModalContainer>
    </form>
  );
};
